export const decisionsConstants = {
    errors: {
        fetchFailed: "Failed to load decisions.",
        fetchDetailFailed: "Failed to load decision details.",
        fetchAnalyticsFailed: "Failed to load decisions analytics.",
        createFailed: "Failed to create decision.",
        updateFailed: "Failed to update decision.",
        deleteFailed: "Failed to delete decision.",
    },
    messages: {
        createSuccess: "Decision created successfully.",
        updateSuccess: "Decision updated successfully.",
        deleteSuccess: "Decision deleted successfully.",
    },
};
